import { FeatureFlag } from "../../feature-flags";
import { useOnboardingFeatureEnabled } from "../../onboarding";

/**
 * True when both `enable-onboarding` and `enable-component-matching-import` are on.
 */
export function useComponentMatchingImportEnabled() {
  return useOnboardingFeatureEnabled(FeatureFlag.EnableComponentMatchingImport);
}
